/* @flow */
import UsersParticipantsTableInput from './UsersParticipantsTableInput';

export default UsersParticipantsTableInput;
